import cx from 'classnames';
import { PropsWithChildren } from 'react';

import { CheckboxSizeType, disabledTextStyle, textSizes } from './utils';

interface LabelProps {
  disabled?: boolean;
  size: CheckboxSizeType;
  htmlFor?: string;
}

interface DescriptionProps {
  disabled?: boolean;
  description: string;
  size: CheckboxSizeType;
}

const Label = ({ disabled, size, children, htmlFor }: PropsWithChildren<LabelProps>) => {
  const { labelSize } = textSizes[size];
  const className = cx(
    'text-black',
    { [disabledTextStyle]: disabled, 'cursor-pointer': htmlFor && !disabled },
    labelSize
  );

  if (htmlFor) {
    return (
      <label htmlFor={htmlFor} className={className}>
        {children}
      </label>
    );
  }

  return <span className={className}>{children}</span>;
};

const Description = ({ disabled, description, size }: DescriptionProps) => {
  const { descriptionSize } = textSizes[size];

  return <span className={cx('text-gray-80', { [disabledTextStyle]: disabled }, descriptionSize)}>{description}</span>;
};

const TextBox = ({ children }: PropsWithChildren) => <div className="flex flex-col">{children}</div>;

TextBox.Label = Label;
TextBox.Description = Description;

export default TextBox;
